import cookie from 'js-cookie'

const prefixKey = 'ss-new_pay'
// token
const tokenKey = `${prefixKey}-token`
export const getToken = () => sessionStorage.getItem(tokenKey) || cookie.get(tokenKey)
export const setToken = (token: string) => {
  sessionStorage.setItem(tokenKey, token)
  cookie.set(tokenKey, token, { expires: 30 })
}
export const removeToken = () => {
  sessionStorage.removeItem(tokenKey)
  cookie.remove(tokenKey)
}

const ordernumberKey = `${prefixKey}-ordernumber`
export const getOrdernumber = () =>
  sessionStorage.getItem(ordernumberKey) || cookie.get(ordernumberKey)

export const setOrdernumber = (ordernumber: string) => {
  sessionStorage.setItem(ordernumberKey, ordernumber)
  cookie.set(ordernumberKey, ordernumber, { expires: 30 })
}
export const removeOrdernumber = () => {
  sessionStorage.removeItem(ordernumberKey)
  cookie.remove(ordernumberKey)
}

export const removeAll = () => {
  removeToken()
  removeOrdernumber()
}
